export default __webpack_public_path__ + "static/media/october.441c3803.png";